export default "__VITE_ASSET__44e895a8__"